import {
    allPass,
    hasPath,
    has
} from 'ramda'

/**
* Function that check if argument resembles a taxonomy object
*/
export const isTaxonomy = allPass([
    hasPath(['labels', 'singular_name']),
    has('slug')
])

export default isTaxonomy